/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebaddrange3Inputs */

const en_placewebaddrange3 = /** @type {(inputs: Placewebaddrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add hours`)
};

const de_placewebaddrange3 = /** @type {(inputs: Placewebaddrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeiten hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add hours" |
*
* @param {Placewebaddrange3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebaddrange3 = /** @type {((inputs?: Placewebaddrange3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebaddrange3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebaddrange3(inputs)
	return de_placewebaddrange3(inputs)
});
export { placewebaddrange3 as "placeWebAddRange" }